// pages/space/space.component.class.jsx
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { BsSun, BsMoonStars } from "react-icons/bs";
import SpaceFly from "../../components/space-fly/space-fly.component";
import HomeFly from "../../components/home-fly/home-fly.component";
import UserProfile from "../../components/user-profile/user-profile.component";
import { setTheme } from "../../redux/theme/theme.actions";
import Station from "../station/station.component";
import "./space.styles.scss";
import "../../theme.styles.scss";

// Navigation subscriptions live in CollabProjectsProvider, above the routes.
export default function Space() {
  const currentUser = useSelector((s) => s.user.currentUser);
  const theme = useSelector((s) => s.theme.theme);
  const dispatch = useDispatch();
  const toggleTheme = () => {
    const next = theme === "dark-theme" ? "paper-theme" : "dark-theme";
    dispatch(setTheme(next));
    document.body.setAttribute("data-theme", next);
    localStorage.setItem("selectedTheme", next);
  };
  return (
    <>
      <div className="space">
        <HomeFly />
        <motion.div className="workspace">
          <SpaceFly />
          <div className="user__settings">
            <div className="station__headermockmobile">
              <Link to="https://www.antlogy.com/">
                <img
                  className="antLogy__logo"
                  src="/antlogy_logo.png"
                  height="40px"
                  alt="Antlogy"
                  style={{ objectFit: "cover" }}
                />
              </Link>
            </div>
            <button
              type="button"
              className="themeToggle"
              aria-label="Toggle theme"
              onClick={toggleTheme}
            >
              {theme === "dark-theme" ? (
                <BsMoonStars size="1.5em" />
              ) : (
                <BsSun size="1.5em" />
              )}
            </button>
            <div className="space__user">
              <UserProfile currentUser={currentUser} />
            </div>
          </div>
        </motion.div>
      </div>
      <Station />
    </>
  );
}
